export type SITE_IDS = "main_ar" | "main_en";

const sites: Record<string, SITE_IDS> = {
  "spl.app": "main_ar",
  "en.spl.app": "main_en",
  "spl.staging.ismgames.com": "main_ar",
  "en.spl.staging.ismgames.com": "main_en",
  "fantasy.spl.com.sa": "main_ar",
  "en.fantasy.spl.com.sa": "main_en",
};

export const getSite = () => sites[window.location.hostname] || "";
